import { useState } from 'react'
import data from '../data/works.json'
import Navbar from '../components/Navbar/Navbar'
import Header from '../components/Header/Header'
import Contacts from '../components/Contacts/Contacts'
import About from '../components/About/About'
import Works from '../components/Works/Works'
import WorkCard from '../components/WorkCard/WorkCard'
import HomeContact from '../components/HomeContact/HomeContact'
import Projects from '../components/Projects/Projects'
import Links from '../components/Links/Links'
import Footer from '../components/Footer/Footer'


const Home = () => {
    const [works, setWorks] = useState(data)

    function filter(button) {
        let filtered = data.filter(elm => elm.category === button)
        setWorks(filtered)
    }

    return(
        <>
            <Navbar />
            <Header />
            <Contacts/>
            <About />
            <Works filter={filter} />
            <WorkCard works={works} />
            <HomeContact />
            <Projects />
            <Links />
            <Footer />
        </>
    )
}

export default Home